import * as React from 'react'
import { Link } from '../../../common/src/components/Link'
import { Spacer } from '../../../common/src/components/core'
import styled from '../../../common/src/components/styled'
import { Colors, Fonts } from '../../../common/src/constants'
import { dateNoYearFmt, timeFmt } from '../../../common/src/date'
import { FetchAgentVirtualTourQuery } from '../../../common/src/types.gen'
import NextVirtualAppointmentInfoDescriptionAttendees from './NextVirtualAppointmentInfoDescriptionAttendees'

const Root = styled.div({
  color: Colors.midway,
  fontSize: 14,
  fontFamily: Fonts.sansBody,
})

interface NextVirtualAppointmentInfoDescriptionProps {
  calendarLink: string
  showing?: NonNullable<FetchAgentVirtualTourQuery['agentVirtualTour']>['showing'] | null
}

const NextVirtualAppointmentInfoDescription = (props: NextVirtualAppointmentInfoDescriptionProps) => {
  const { calendarLink, showing } = props

  if (showing == null || showing.calEvent == null) {
    return (
      <Root>
        There are no scheduled appointments on <Link to={calendarLink}>your calendar »</Link>
      </Root>
    )
  }

  const { unitType, leasingTask, showingContactsPlanningToAttend, calEvent } = showing
  const { displayName } = leasingTask
  const { timeStart, timeEnd } = calEvent

  return (
    <Root>
      <NextVirtualAppointmentInfoDescriptionAttendees
        showingContactsPlanningToAttend={showingContactsPlanningToAttend}
      />
      <Spacer height={8} />
      <div>
        {dateNoYearFmt(timeStart)} · {timeFmt(timeStart)} — {timeFmt(timeEnd)}
      </div>
      <Spacer height={4} />
      <div>
        {displayName} · {unitType}
      </div>
    </Root>
  )
}

export default NextVirtualAppointmentInfoDescription
